import React, { useState, useEffect } from 'react';
import { Button } from '../Forms/Forms';
import { isMobile, priceFormat } from '../../helpers/helpers';
import './ComplementaryOperations.scss'
import ComplementaryOperationItem from './ComplementaryOperationItem';
import CONSTANTS from '../../Constants';
import { useSelector, useDispatch } from 'react-redux';
import StickyButton from '../Forms/StickyButton';
// import PopIn from '../PopIn/PopIn';
// import warningImg from '../../images/AP/ap-Alert-Outline.svg'
// import CONSTANTS from '../../Constants';

const ComplementaryOperations = ({ complementaryOperations, forfaitPrice, onComplementaryOperationsButtonClicked, onComplementaryOperationChecked }) => {
    const selectedMandatoryForfaitsFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const [selectedMandatoryOperations, setSelectedMandatoryOperations] = useState(selectedMandatoryForfaitsFromStore)
    const [MandatoryOperationsTotalPrice, setMandatoryOperationsTotalPrice] = useState(0)
    const [showDetail, setShowDetail] = useState(false)

    useEffect(() => {
        // console.log(complementaryOperations.filter(operation => operation.isChecked))
        // complementaryOperations.forEach(oper=>handleAddToCheckedMandatoryOperations(oper))
        // setSelectedMandatoryOperations(complementaryOperations.filter(operation => operation.isChecked))
        setMandatoryOperationsTotalPrice(calculateMandatoryOperationsTotalPrice())
        return () => {
        }
    }, [])

    const handleAddToCheckedMandatoryOperations = (MandOperation) => {

        !isMobile() && onComplementaryOperationChecked(MandOperation)
        let selectedManOpera = selectedMandatoryOperations
        if (MandOperation.isChecked) {
            selectedManOpera = [...selectedMandatoryOperations, MandOperation]
            setSelectedMandatoryOperations(selectedManOpera)
        }
        else {
            selectedManOpera = selectedMandatoryOperations.filter(item => item.Items[0].Ref !== MandOperation.Items[0].Ref)
            setSelectedMandatoryOperations(selectedManOpera)
        }
        setMandatoryOperationsTotalPrice(calculateMandatoryOperationsTotalPrice())
    }

    const calculateMandatoryOperationsTotalPrice = () => {
        const checkedComplementaryOperations = complementaryOperations.filter(item => item.isChecked)
        let totalPrice = checkedComplementaryOperations.reduce((prevValue, currentValue) =>
            prevValue + currentValue.Items[0].Prix, 0)
        return totalPrice
    }

    return (
        <>
            <ul className="complementary-forfait-wrapper">
                {!isMobile() &&
                    <div className='mandatory-operations-title_block'>
                        <div className='mandatory-operations-title'>
                            {CONSTANTS.LABELS.needs_basket_maintenance_label7}
                        </div>
                        <p className='detail'>{CONSTANTS.LABELS.needs_basket_maintenance_label8}</p>
                    </div>
                }
                {
                    complementaryOperations.map((complementaryOperation, index) => {
                        return (
                            <ComplementaryOperationItem
                                key={index}
                                complementaryOperation={complementaryOperation}
                                addToCheckedMandatoryOperations={handleAddToCheckedMandatoryOperations}
                            />
                        )
                    })
                }
                {!isMobile() && <li className="complementary-forfait-block-totalPrice">
                    <div className="total-price">{CONSTANTS.LABELS.needs_basket_maintenance_label9}</div>
                    <div className="complementary-forfait-totalPrice">{priceFormat(forfaitPrice + MandatoryOperationsTotalPrice)} <span className="tax-text"> {CONSTANTS.LABELS.needs_basket_label2}</span></div>
                </li>}

            </ul>
            {isMobile() && <StickyButton
                label={CONSTANTS.LABELS.common_v2_continue}
                isDisabled={false}
                handleClick={() => onComplementaryOperationsButtonClicked(selectedMandatoryOperations)}
            >

            </StickyButton>}
            {/* {isMobile() && <div className='sticky-button-block'>

                <Button
                    isDisabled={false}
                    handlClick={() => onComplementaryOperationsButtonClicked(selectedMandatoryOperations)}
                >
                    {CONSTANTS.LABELS.common_v2_continue}
                </Button>
            </div>} */}
        </>
    )
}

export default ComplementaryOperations;